// src/components/NewPost.jsx
import React, { useState } from "react";
import { FiImage, FiSend, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";

/**
 * Yeni duyuru bileşeni
 * - Dropdown (rol) kaldırıldı.
 * - Başlık, Firma adı, İçerik ve Görsel alanları var.
 * - onSubmit({ title, author_company_name, content, imageFile })
 */
export default function NewPost({
  onSubmit,
  allowImage = true,
}) {
  const [title, setTitle] = useState("");
  const [company, setCompany] = useState("");
  const [content, setContent] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const { t } = useTranslation();

  const handleImage = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setImageFile(null);
      setImagePreview(null);
      return;
    }
    setImageFile(file);
    const url = URL.createObjectURL(file);
    setImagePreview(url);
  };

  const clearImage = () => {
    setImageFile(null);
    if (imagePreview) URL.revokeObjectURL(imagePreview);
    setImagePreview(null);
  };

  const submit = async (e) => {
    e.preventDefault();
    const t = title.trim();
    const c = content.trim();
    if (!t || !c) return; // başlık ve duyuru zorunlu
    setBusy(true);
    try {
      await onSubmit({
        title: t,
        author_company_name: company.trim(),
        content: c,
        imageFile,
      });
      setTitle("");
      setCompany("");
      setContent("");
      clearImage();
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="composer" onSubmit={submit}>
      {allowImage && (
        <div className="composer__image">
          {imagePreview ? (
            <div className="composer__image-preview">
              <img src={imagePreview} alt={t("composer.previewAlt")} />
              <button
              type="button"
              className="btn-ghost"
              onClick={clearImage}
              title={t("composer.removeImage")}
            >
              <FiX />
              {t("composer.removeImage")}
            </button>
            </div>
          ) : (
            <label className="chip chip--active composer__image-trigger" title={t("composer.addImage")}>
              <FiImage />
              <span style={{ marginLeft: 8 }}>{t("composer.addImage")}</span>
              <input type="file" hidden accept="image/*" onChange={handleImage} />
            </label>
          )}
        </div>
      )}

      <div className="composer__row">
        <input
          className="composer__input"
          type="text"
          placeholder={t("composer.titlePlaceholder")}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={150}
          aria-label={t("composer.titlePlaceholder")}

          required
        />
      </div>

      <div className="composer__row">
        <input
          className="composer__input"
          type="text"
          placeholder={t("composer.companyPlaceholder")}
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          maxLength={120}
          aria-label={t("composer.companyPlaceholder")}
        />
      </div>

      <div className="composer__row">
        <textarea
          className="composer__input"
          rows={4}
          placeholder={t("composer.contentPlaceholder")}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          maxLength={2000}
          aria-label={t("composer.contentPlaceholder")}
          required
        />
      </div>

      <div className="composer__actions">
        <button
          className="btn-primary"
          type="submit"
          disabled={busy || !title.trim() || !content.trim()}
          aria-label={t("composer.share")}
        >
          <FiSend style={{ marginRight: 6 }} /> {t("composer.share")}
          </button>
      </div>
    </form>
  );
}